// extracted by mini-css-extract-plugin
module.exports = {"chart":"Chart_chart__uVQsY","loading-spinner":"Chart_loading-spinner__oA__t"};